import { Badge } from '@chakra-ui/react';

export interface InvoiceReasonFlagBadgeProps {
    label: string;
    colorScheme: string;
}

const brownBadgeSx = {
    bg: '#EDE7E1',
    color: '#4A3728',
    _dark: {
        bg: 'rgba(110, 85, 68, 0.45)',
        color: '#F5EDE6',
    },
};

/** Matches Reason column badges on the invoices list (`list/invoicesListPageUtils`). */
export function InvoiceReasonFlagBadge({ label, colorScheme }: InvoiceReasonFlagBadgeProps) {
    const compact = label.length > 10;
    const isBrown = colorScheme === 'brown';
    return (
        <Badge
            {...(isBrown
                ? { sx: brownBadgeSx }
                : { colorScheme, variant: 'subtle' as const })}
            px={compact ? 1.5 : 2}
            py={0.5}
            fontSize={compact ? '2xs' : 'xs'}
            fontWeight="semibold"
            whiteSpace="nowrap"
            lineHeight="short"
        >
            {label}
        </Badge>
    );
}
